import React from 'react'
import Link from 'gatsby-link'
import config from '../../../config/SiteConfig';

//  Components
import Navigation from '../Navigation/Navigation.js'
import Share from '../Share/Share.js'
import logoUrl, { ReactComponent as Logo } from './cmwf-logo.svg'
import homeUrl, { ReactComponent as Home } from '../../assets/svg/icon-home.svg'

//  Styles
import styles from './Header.module.scss';

const Header = ({ siteYear, siteSubtitle, isHome, themes, states, location, social, site }) => (
  <header className={ styles.header + " l-container" }>
    {/* <div className={ styles.embargo }>
      <p>Embargoed Until 12:01, Thursday, May 3</p>
    </div> */}
    <div className={ styles.header_title_wrap }>
      <div className={ [styles.logo, isHome ? "" : styles.header_title_shown].join(" ") }>
        <a href="http://www.commonwealthfund.org"><Logo /></a>
      </div>
      { isHome ? "" :
      <h1 className={ [styles.header_title, isHome ? styles.header_title_hidden : ""].join(" ") }>
        <Link
          to="/"
          style={{
            textDecoration: 'none',
          }}
        >
          <div className={ styles.home }><Home /></div>
          <div className={ styles.site__title__year }>
            <strong className={ styles.site__year }>{siteYear}</strong>
            <div className={ styles.site__title }>{siteSubtitle}</div>
          </div>
        </Link>
      </h1>
      }
    </div>
    <Navigation themes={ themes } states={ states } />
    <Share site={ site } location={ location }  social={ social } />
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js